import React from "react";
import { useLocation, useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Paper,
  Stack,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";

export default function OrganizerRequestSent() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const requestId = state?.requestId || "";

  const copy = async () => {
    if (!requestId) return;
    try {
      await navigator.clipboard.writeText(requestId);
    } catch {}
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "radial-gradient(1200px 600px at top center, rgba(0,180,255,0.12), transparent 60%), radial-gradient(900px 500px at 10% 30%, rgba(120,90,255,0.10), transparent 55%), #040912",
        display: "flex",
        alignItems: "center",
        py: { xs: 5, md: 9 },
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2.8, md: 4 },
            borderRadius: { xs: "18px", md: "24px" },
            background: "rgba(255,255,255,0.06)",
            backdropFilter: "blur(18px)",
            border: "1px solid rgba(255,255,255,0.12)",
          }}
        >
          <Stack spacing={2.2} alignItems="flex-start">
            <Stack direction="row" spacing={1} alignItems="center">
              <CheckCircleRoundedIcon sx={{ color: "rgba(0,180,255,0.95)" }} />
              <Typography variant="h5" sx={{ fontWeight: 900 }}>
                Solicitação enviada 🎉
              </Typography>
            </Stack>

            <Typography sx={{ color: "rgba(255,255,255,0.75)" }}>
              Recebemos seus dados. Agora é só aguardar a análise do time. Assim
              que aprovar, você recebe acesso ao painel do organizador.
            </Typography>

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              flexWrap="wrap"
            >
              <Chip
                label="Status: pending"
                sx={{
                  bgcolor: "rgba(255,193,7,0.14)",
                  color: "rgba(255,255,255,0.9)",
                  border: "1px solid rgba(255,193,7,0.25)",
                }}
              />
              {requestId ? (
                <Chip
                  label={`Protocolo: ${requestId.slice(0, 8)}...`}
                  sx={{
                    bgcolor: "rgba(255,255,255,0.08)",
                    color: "rgba(255,255,255,0.85)",
                    border: "1px solid rgba(255,255,255,0.14)",
                  }}
                />
              ) : null}
            </Stack>

            {requestId ? (
              <Button
                onClick={copy}
                startIcon={<ContentCopyRoundedIcon />}
                variant="outlined"
                sx={{
                  borderColor: "rgba(255,255,255,0.22)",
                  color: "rgba(255,255,255,0.88)",
                  borderRadius: "14px",
                }}
              >
                Copiar protocolo
              </Button>
            ) : null}

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.2}
              sx={{ pt: 1 }}
            >
              <Button
                variant="contained"
                onClick={() => navigate("/organizadores")}
                sx={{ borderRadius: "14px", fontWeight: 900, px: 2.4, py: 1.2 }}
              >
                Voltar para organizadores
              </Button>

              <Button
                component={RouterLink}
                to="/eventos"
                variant="text"
                sx={{ color: "rgba(255,255,255,0.72)" }}
              >
                Ver eventos
              </Button>
            </Stack>

            <Typography
              sx={{ color: "rgba(255,255,255,0.55)", fontSize: 12, pt: 1 }}
            >
              ONURB Pass • Área do Organizador • 2026
            </Typography>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}
